interface SectionHeadingProps {
  eyebrow: string;
  title: string;
  desc?: string;
  icon?: string;
  align?: 'left' | 'center';
}

export default function SectionHeading({
  eyebrow,
  title,
  desc,
  icon = 'ri-price-tag-3-line',
  align = 'left',
}: SectionHeadingProps) {
  const isCenter = align === 'center';
  return (
    <div
      className={`flex flex-col gap-3 mb-7 md:mb-9 ${
        isCenter ? 'items-center text-center' : 'items-start text-left'
      }`}
    >
      <div className="flex items-center gap-2">
        <span className="w-6 h-6 flex items-center justify-center rounded-md bg-primary-100 text-primary-700">
          <i className={`${icon} text-sm`}></i>
        </span>
        <span className="text-xs md:text-sm tracking-[0.2em] font-label text-primary-700 uppercase">
          {eyebrow}
        </span>
      </div>
      <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 leading-snug">
        {title}
      </h2>
      {desc ? (
        <p className={`text-sm md:text-base text-foreground-600 leading-relaxed ${isCenter ? 'max-w-3xl' : 'max-w-3xl'}`}>
          {desc}
        </p>
      ) : null}
    </div>
  );
}